<template>
	<div>
		<v-app-bar flat app absolute color="white">
			<v-app-bar-nav-icon color="primary" @click="handleMiniDrawer"></v-app-bar-nav-icon>

			<v-toolbar-title>Interface Service</v-toolbar-title>

			<v-spacer></v-spacer>

			<v-menu offset-y>
				<template v-slot:activator="{ on, attrs }">
					<v-btn icon l v-bind="attrs" v-on="on">
						<v-icon color="primary">mdi-account</v-icon>
					</v-btn>
				</template>
				<v-list>
					<v-list-item><v-btn text link :to="'/MeinProfil'"> Mein Profil </v-btn> </v-list-item>
					<v-list-item
						><v-btn v-if="token" @click="handleLogout" data-testid="logout" text>
							{{ buttonText }}
						</v-btn>
					</v-list-item>
				</v-list>
			</v-menu>
		</v-app-bar>
	</div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import api from '../common/auth/api';
export default {
	name: 'TopBar',

	data: () => ({
		buttonText: 'Logout',
	}),
	props: {
		value: Boolean,
	},
	computed: {
		...mapState({
			token: state => state.auth.token,
		}),
	},

	methods: {
		...mapActions({
			logout: 'auth/logout',
		}),
		handleMiniDrawer() {
			this.$emit('input', !this.value);
		},
		handleLogout() {
			this.logout().then(() => {
				this.$router.push('/login');
			});
		},
	},
};
</script>
